import { useEffect, useState } from 'react';
import { useImageLoader } from './useImageLoader';

const imageSrc = 'https://guac.streamgo.co.uk/streamGo-logo-final.png';

export const isWebsocketValid = async (): Promise<boolean> => {
  const wsUri =
    'wss://guac.streamgo.co.uk/socket.io/?EIO=3&transport=websocket';

  return new Promise(resolve => {
    const supportsWebSockets =
      'WebSocket' in window || 'MozWebSocket' in window;

    // check basic support
    if (!supportsWebSockets) {
      resolve(false);
    }

    const websocket = new WebSocket(wsUri);

    // check opening a websocket connection to StreamGo
    const sendMessage = (message: string) => websocket.send(message);
    const onOpen = () => sendMessage('Dolby testing websockets');
    const onClose = () => resolve(true);
    const onMessage = () => websocket.close();
    const onError = (evt: Event) => {
      console.error(evt);
      resolve(false);
    };

    websocket.onopen = () => onOpen();
    websocket.onclose = () => onClose();
    websocket.onmessage = () => onMessage();
    websocket.onerror = evt => onError(evt);
  });
};

export const useIsLiveSlidesValid = () => {
  const [websocketValid, setWebsocketValid] = useState(false);
  const canAccessGuac = useImageLoader(imageSrc);

  useEffect(() => {
    const checkWebsocket = async () => {
      let isValid = false;
      try {
        isValid = await isWebsocketValid();
      } catch (err) {
        console.error(err);
      }
      setWebsocketValid(isValid);
    };
    checkWebsocket();
  }, []);

  return {
    websocketValid,
    canAccessGuac,
    isLiveSlidesValid: websocketValid && canAccessGuac,
  };
};
